import React from 'react';

export const headerStyle: React.CSSProperties = {
  height: 65,
  padding: '0 24px',
  lineHeight: '64px',
  borderBottom: '1px solid #e0e0e0',
};

export const contentStyle: React.CSSProperties = {
  textAlign: 'center',
  minHeight: 'calc(100dvh - 129px)',
  // lineHeight: '120px',
  backgroundColor: '#fcfcfc',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'start',
  width: '100%',
  height: 'auto',
  flex: 1,
};

export const mobileContentStyle: React.CSSProperties = {
  ...contentStyle,
  minHeight: 'calc(100dvh - 60px)',
  paddingBottom: '70px',
  overflow: 'auto',
};

export const footerStyle: React.CSSProperties = {
  textAlign: 'center',
  backgroundColor: '#f0f2f6',
};

export const layoutStyle: React.CSSProperties = {
  overflow: 'hidden',
  minHeight: '100dvh',
};

export const logoStyle: React.CSSProperties = {
  height: '40px',
  marginTop: '-5px',
};

export const mobileHeaderStyle: React.CSSProperties = {
  ...headerStyle,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '50px',
  lineHeight: '50px',
  padding: '0 16px',
};

export const bottomNavStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: '0',
  left: '0',
  right: '0',
  height: '60px',
  backgroundColor: '#ffffff',
  zIndex: 1000,
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  padding: '0 5px',
  // borderRadius: '8px',
  boxShadow: '0 0px 10px rgba(0, 0, 0, 0.1)',
  fontWeight: '230',
  lineHeight: '27px',
  fontFamily: '"Open Sans", sans-serif',
};

export const bottomNavItemStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  color: '#000000',
  padding: '8px 0',
  flex: 1,
  textAlign: 'center',
  transition: 'all 0.5s ease',
};

export const bottomNavSelectedItemStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  padding: '6px 0',
  flex: 1,
  textAlign: 'center',
  transition: 'all 0.5s ease',
  backgroundColor: '#FFF8E6',
  borderRadius: '8px',
};

export const bottomNavIconStyle: React.CSSProperties = {
  fontSize: '22px',
};

export const bottomNavLabelStyle: React.CSSProperties = {
  fontSize: '12px',
  lineHeight: '1',
  marginTop: '4px',
  transition: 'opacity 0.3s ease',
};
